module.exports = __webpack_public_path__ + "img/google.63c57709.svg";